module.exports = __webpack_public_path__ + "img/3.b6c5b2f6.png";